import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { MentoringDocumentGridDataService } from 'common/services/data-services/student/mentoring-doc/mentoring-grid-data.service';
import { MentoringDocumentModel } from 'common/models/page-models/mentoring-document/mentoring-document-data.model';
import { MentoringDocumentGridMetaModel } from 'common/models/page-models/mentoring-document/mentoring-document-grid-meta.model';
import { MentoringDocumentListingModel } from 'common/models/page-models/mentoring-document/mentoring-document-grid.model';


@Injectable({
    providedIn: 'root'
})
export class MentoringGridWidgetService extends GridWidgetService<MentoringDocumentModel, MentoringDocumentListingModel> {
    constructor(protected override ds: MentoringDocumentGridDataService, protected systemService: SystemService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new MentoringDocumentGridMetaModel().getMetaModel();
        return meta;
    }

}